import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import ModelBasedSelectorSpec from "./ModelBasedSelectorSpec";
import idArgSelector from "./idArgSelector";

var MapSelectorSpec =
/*#__PURE__*/
function (_ModelBasedSelectorSp) {
  _inheritsLoose(MapSelectorSpec, _ModelBasedSelectorSp);

  function MapSelectorSpec(_ref) {
    var _this;

    var field = _ref.field,
        selector = _ref.selector,
        other = _objectWithoutProperties(_ref, ["field", "selector"]);

    _this = _ModelBasedSelectorSp.call(this, other) || this;
    _this._field = field;
    _this._selector = selector;
    return _this;
  }

  var _proto = MapSelectorSpec.prototype;

  _proto.createResultFunc = function createResultFunc(parentSelector) {
    var _this2 = this;

    return function (state) {
      var _this2$_orm;

      for (var _len = arguments.length, other = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        other[_key - 1] = arguments[_key];
      }

      var parentResult = parentSelector.apply(void 0, [state].concat(other));
      if (parentResult === null) return null;

      var ormState = (_this2$_orm = _this2._orm).stateSelector.apply(_this2$_orm, [state].concat(other));

      var session = _this2._orm.session(ormState);

      var idArg = idArgSelector.apply(void 0, [state].concat(other));
      var idAttribute = session[_this2._field.toModelName].idAttribute;

      if (typeof idArg === "undefined" || Array.isArray(idArg)) {
        return parentResult.map(function (ref) {
          return ref === null ? null : _this2._selector(state, ref[idAttribute]);
        });
      }

      return _this2._selector(state, parentResult[idAttribute]);
    };
  };

  return MapSelectorSpec;
}(ModelBasedSelectorSpec);

export { MapSelectorSpec as default };